import { defineMessages } from 'react-intl';

export default defineMessages({
  step1: {
    id: 'features.timelineProfile.step1',
    defaultMessage: 'Inserimento dati',
    description: '',
  },
  step2: {
    id: 'features.timelineProfile.step2',
    defaultMessage: 'Verifica codice OTP',
    description: '',
  },
  step2mobile: {
    id: 'features.timelineProfile.step2mobile',
    defaultMessage: 'Verifica OTP',
    description: '',
  },
  step3: {
    id: 'features.timelineProfile.step3',
    defaultMessage: 'Riepilogo',
    description: '',
  },
});
